import vmClient from 'app/services/vmClient';
import { Entity, IEntityType } from 'app/types/entity';
import { Section, ISection } from 'app/constants/schemas/Section';
import { IParagraph, Paragraph } from 'app/constants/schemas/Paragraph';

export type ArticleSectionType = ISection & {
  associations: {
    paragraphs: IParagraph[];
  };
};

export type ArticleSection = Entity<ArticleSectionType>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ArticleSection: IEntityType<ArticleSectionType> = vmClient.defineClass({
  typeName: 'ArticleSection',
  version: 8,
  lockable: true,
  persisted: true,
  extends: Section,
  associations: {
    paragraphs: {
      type: Paragraph,
      collection: true,
    },
  },
});
